var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all",attrs:{"id":"app"}},[(_vm.FoundPageFlag)?_c('Header'):_vm._e(),_c('router-view',{on:{"disable":function($event){_vm.FoundPageFlag = false}}}),(_vm.FoundPageFlag)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }